import { FeatureComparison } from "../_copy-template"
import UserExperience from "~images/pages/comparison/features/ui-animation.gif"

export function getUserExperienceCopy(
    competitor: string,
    hidden?: boolean
): FeatureComparison {
    return {
        name: "User Experience",
        image: UserExperience,
        chckup: {
            showCheck: true,
            description:
                "With Chckvet, we strive to make using our platform as user-friendly as possible. We are constantly working with veterinary practices, pet owners, and designers on how we can make Chckvet super easy to use.",
        },
        competitor: {
            showCheck: false,
            hidden: hidden,
            description: `See for yourself and decide if ${competitor}'s user experience is right for you.`,
        },
    }
}
